import React, { useContext } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import MainNavbar from 'components/Navbars/MainNavbar.js'
import MainFooter from 'components/Footer/MainFooter.js'

import routes from 'routes.js'
import ThemeContext from 'services/providers/ThemeContext'

const Main = () => {
  const { lightMode } = useContext(ThemeContext)
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views)
      }
      if (prop.layout === '/') {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        )
      } else {
        return null
      }
    })
  }
  const getActiveRoute = (routes) => {
    let activeRoute = 'Default Brand Text'
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views)
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute
        }
      } else {
        if (
          window.location.pathname.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          return routes[i].name
        }
      }
    }
    return activeRoute
  }
  const getFullPageName = (routes) => {
    let pageName = getActiveRoute(routes)
    switch (pageName) {
      case 'Home':
        return 'home'
      default:
        return 'Default Brand Text'
    }
  }

  return (
    <>
      <div className="flex flex-col min-h-screen bg-background">
        <MainNavbar />
        <div
          className={`flex-grow ${lightMode ? '' : 'bg-black'} min-h-screen`}
        >
            <Switch>
              {getRoutes(routes)}
              <Redirect to="/admin/dashboard" />
            </Switch>
        </div>
        <MainFooter />
      </div>
    </>
  )
}

export default Main
